import styled from "styled-components";

export const Section = styled.section`
  padding: 40px 20px;
  color: var(--rose-70);

  @media (max-width: 1080px) {
    padding: 40px 100px;
  }
  @media (max-width: 768px) {
    padding: 40px;
  }
  @media (max-width: 480px) {
    padding: 40px 20px;
  }
`;

export const Title = styled.h1`
  font-size: 36px;
  color: var(--teal);
  margin-bottom: 30px;
`;

export const CarouselWrapper = styled.div`
  overflow: hidden;
  max-width: 960px;
  margin: 0 auto;
  position: relative;
  padding: 40px 0;
`;

export const Track = styled.div`
  display: flex;
  transition: ${(props) =>
    props.$transition ? "transform 0.6s ease-in-out" : "none"};
  transform: translateX(${(props) => `-${props.$translate}px`});
  width: ${(props) => props.$trackWidth}px;
  min-height: 320px;
`;

export const Card = styled.div`
  width: ${(props) => props.$width}px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease,
    opacity 0.3s ease;
  transform: ${(props) =>
    props.$position === 0
      ? "scale(1.05)"
      : props.$position === -1 || props.$position === 1
      ? "scale(0.95)"
      : "scale(1)"};
  filter: ${(props) =>
    props.$position === -1 || props.$position === 1
      ? "blur(1px) brightness(0.8)"
      : "none"};
  opacity: ${(props) => (Math.abs(props.$position) <= 1 ? 1 : 0)};
  pointer-events: ${(props) =>
    Math.abs(props.$position) <= 1 ? "auto" : "none"};
`;

export const CardContent = styled.div`
  background-color: var(--white-5);
  border: 1px solid var(--rose-20);
  border-radius: 12px;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: ${(props) =>
    props.$isCenter ? "0 0 20px var(--white-10)" : "0 0 10px var(--dark-30)"};

  @media (max-width: 768px) {
    box-shadow: ${(props) =>
      props.$isCenter ? "0 0 8px var(--white-10)" : "0 0 4px var(--dark-30)"};
  }
`;

export const Feedback = styled.p`
  font-size: 0.95rem;
  line-height: 1.4em;
`;

export const Cite = styled.cite`
  display: block;
  margin-top: 15px;
  font-style: normal;
  color: var(--rose-70);
  font-weight: bold;
`;

export const Dots = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 10px;
`;

export const Dot = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ $active }) =>
    $active ? "var(--teal)" : "var(--gray)"};
  cursor: pointer;
  transition: background 0.3s;
`;
